import { useStore } from 'vuex';
import HELPER from '@/app/utils/HELPER';
import { base } from '@/app/editor/sidebar/constant';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import { trimProductTitlePreview, changeProductTitlePreview } from '@/app/utils/assignedProductHelper';

import type { Product } from '../type';

export const usePickProduct = () => {
  const store = useStore();

  const $element = store.getters['productPicker/GET_SELECTER_ELEMENT'];

  const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');

  const applyStatusSidebarSettings = (status: string) => {
    const $gfProductStatus = $element.closest('.gfSGSettings').find('.gf-product-status');
    if (!status || ['active'].includes(status)) {
      $gfProductStatus.html('');
      $gfProductStatus.removeClass('active archived');
      return;
    }
    $gfProductStatus.addClass('active');
    $gfProductStatus.removeClass('archived');
    if (status === 'archived') {
      $gfProductStatus.addClass(status);
    }
    status = HELPER.capitalizeFirstLetter(status);
    $gfProductStatus.html(status);
  };

  const addClassInputByStatus = (status: string) => {
    const $gfInputFieldBox = $element.closest('.gfSGSettings').find('.gfInputField .gfInputFieldBox input');
    $gfInputFieldBox.removeClass('has-status');
    if (status !== 'active') {
      $gfInputFieldBox.addClass('has-status');
    }
  };

  const updateElementInfo = (productAttr: { title: any; image: any; id: any; handle: any }) => {
    const { title, image, id, handle } = productAttr;
    changeProductTitlePreview($element, title);
    $element.attr('data-value', title);
    $element.attr('data-id', id);

    // Fix lại đường dẫn tới pHandle
    const $pHandle = $element.parents('.columns').siblings().find('#pHandle');
    $pHandle.attr('default-value', handle);
    $pHandle.attr('value', handle).val(handle);

    // Fix lại đường dẫn tới pid
    const $pid = $element.parents('.columns').siblings().find('#pid');
    $pid.attr('default-value', id);
    $pid.attr('value', id).val(id).trigger('input-change').trigger('history-change');

    updateProductImageSelected(image);

    // Refresh lại VariantSelector sau khi pick Product
    refreshVariantSelector();
  };

  const updateProductImageSelected = (productImage: any) => {
    const $gfSGSettings = $element.closest('.gfSGSettings');
    $gfSGSettings.find('.gfProductThumb').find('img').attr('src', productImage);
  };

  const refreshVariantSelector = () => {
    // update variant setting in sidebar
    const $sidebarVariantSetting = jQuery('input#variant.gf-field-item') as any;

    // Xóa các options Variant hiện tại
    if ($sidebarVariantSetting.data('gfvariantselector')) {
      const oldSelectors = $sidebarVariantSetting.siblings('div.gryff_layout-onion');
      oldSelectors.remove();

      $sidebarVariantSetting.removeData('gfvariantselector');
    }

    // Init new Variant
    $sidebarVariantSetting.gfVariantSelector({
      /**
       * gfVariantSelector.detectChange
       */
      detectChange: function () {},
    });
  };

  const updateDataSettings = function (productAttr: { title: any; image: any; id: any; handle: any }) {
    const { title, image, id, handle } = productAttr;
    const fields = getSettingCurrentTarget();

    const fieldSize = fields.length;
    for (let i = 0; i < fieldSize; i++) {
      if (fields[i].name === 'product') {
        fields[i].default_value = title;
        // Update giá trị của manual select
        fields[i].items[2].default_value = title;
        fields[i].items[2].default_value_image = image;
        fields[i].items[2].default_value_id = id;
      }
      if (fields[i].name === 'pid') {
        fields[i].default_value = id;
      }
      if (fields[i].name === 'pHandle') {
        fields[i].default_value = handle;
      }
    }

    saveSettingCurrentTarget(fields);
  };

  const getSettingCurrentTarget = () => {
    const moduleId = getCurrentModuleId();
    const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
    const $settings = store.getters['editor/GET_DATA_SETTING_BY_KEY'](keySettings);
    return JSON.parse($settings);
  };

  const getCurrentPickedProduct = (callback: () => void) => {
    const fields = getSettingCurrentTarget();
    const fieldSize = fields.length;
    for (let i = 0; i < fieldSize; i++) {
      if (fields[i].name === 'pid') {
        const currentPickedProduct = window._productArray.find(
          (p: { id: number }) => p.id === parseInt(fields[i].default_value),
        );
        if (currentPickedProduct) {
          Object.assign(currentPickedProduct, { isPicked: true });
          store.commit('productPicker/ADD_PICKED_PRODUCT', currentPickedProduct);
        }
      }
    }
    if (callback) callback();
  };

  const saveSettingCurrentTarget = (fields: any) => {
    const moduleId = getCurrentModuleId();
    const keySettings = HELPER.getKeyDataSetting(base._settings, moduleId);
    store.commit('editor/SET_DATA_SETTINGS', {
      id: keySettings,
      value: JSON.stringify(fields),
    });
  };

  const getCurrentModuleId = () => {
    return $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');
  };

  const onPickProduct = (product: Product) => {
    if (!product) return;
    const { image, title, id, handle, status } = product;

    HELPER.updateProductInList(product);

    const productAttr = {
      title: trimProductTitlePreview(title || ''),
      image: image ? image.src : HELPER.getDefaultNoImage(),
      id: id,
      handle: handle,
    };

    applyStatusSidebarSettings(status || '');
    addClassInputByStatus(status || '');
    setTimeout(function () {
      updateElementInfo(productAttr);
    }, 100);
    updateDataSettings(productAttr);
  };

  return { onPickProduct, getCurrentPickedProduct, getCurrentModuleId };
};
